import { useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { clearMessage } from "../../redux/slices/messageSlice";

const NavigationToast = ({ message }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const redirectTo = message.redirectTo;

  const handleToastClick = () => {
    if (redirectTo) {
      toast.dismiss();
      setTimeout(() => navigate(redirectTo), 200);
    }
  };

  useEffect(() => {
    if (!message) return;

    if (message.error) {
      toast.error(message.error, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        onClick: handleToastClick,
      });
    } else if (message.success) {
      toast.success(message.success, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        onClick: handleToastClick,
      });
    }

    const timer = setTimeout(() => dispatch(clearMessage()), 2000);
    return () => clearTimeout(timer);
  }, [message, dispatch]);

  return null;
};

export default NavigationToast;
